module.exports = __webpack_public_path__ + "static/media/group.9c4e1f91.png";